import React from 'react'
import { NavLink } from "react-router-dom";
const SubLink = (props) => {
    return (
        <NavLink activeClassName={"inact"} style={{ width: "100%" }} className="nav-link p-hover p-3 w3-text-white checklink stylefont" to={props.To}>
            <div className="pl-5">
                <span className="labelName"> &nbsp;{props.subLink}</span>
            </div>
        </NavLink>
    )
}

export default SubLink